import { Skeleton } from 'primereact/skeleton';
import classes from './JobPasteSkeleton.module.scss';

const JobPasteSkeleton = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <div className={classes.tabSkeletonTable}>
        <Skeleton height="5rem"></Skeleton>
        <Skeleton height="20rem"></Skeleton>
        <Skeleton height="5rem"></Skeleton>
        <Skeleton height="5rem"></Skeleton>
        <Skeleton height="5rem"></Skeleton>
        <Skeleton height="5rem"></Skeleton>
      </div>
    </div>
  );
};

export default JobPasteSkeleton;
